import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/ids/group-id/$id/_$id/devices/')({
  component: Devices
});
function Devices() {
  return <ComingSoonCover />;
}